'use client'
import React, { useState, useEffect, useRef } from 'react'
// import { useSession } from 'next-auth/react'
import Image from 'next/image'
import LinkComponent from './LinkComponent'
import { AiOutlineLayout, AiFillHeart, AiOutlineHeart } from "react-icons/ai"
import { BiArea, BiSolidArea } from "react-icons/bi";
import { FaBed, FaBath } from "react-icons/fa"
import tailwindConfig from '@tailwind.config'
import CurrencySymbol from '@components/CurrencySymbol'
import { IoMdVideocam } from 'react-icons/io'

// import { sendLike } from '@services/sendLike'
// import CurrencySymbol from '@components/CurrencySymbol'
// import { categoryTypes } from '@constants'


const LayoutCard = ({ property, imageWidth = 400, imageHeight = 300, dictionary, lang }) => {

    return (
        <div className='relative w-full m-1 rounded-lg shadow-md hover:shadow-sm hover:shadow-maincolor'>
            <LinkComponent
                className='w-full'
                href={'/properties/' + property.slug}
            >
                <div className='relative w-full aspect-[4/3] rounded-t-md overflow-hidden'>
                    <Image
                        // placeholder="blur"
                        // blurDataURL={property.blur}
                        // className='object-fit'
                        className='object-cover'
                        src={property.cover}
                        // width={imageWidth}
                        // height={imageHeight}
                        fill={true}
                        alt={property.slug}
                    />
                    {(property.videoUrl) ? (
                        <div className='absolute w-full bottom-1 left-1 flex flex-row flex-wrap'>
                            {/* {(property.foreignQuota && property.category == 'Condo' && property.saleType == 'sale') ? (
                                <div className={`rounded-md p-1 text-third border-third border-[1px] text-sm mr-1 flex flex-row items-center`}><MdPlaylistAddCheckCircle /><span className='ml-1'>Foreign Quota</span></div>
                            ) : null} */}
                            {property.videoUrl ? (
                                <div className={`rounded-md p-1 text-light bg-red-800 text-sm mr-1 flex flex-row items-center`}><IoMdVideocam /><span className='ml-1'>{dictionary.video}</span></div>
                            ) : null}
                            {/* {property.isSeaView ? (
                                <div className={`rounded-md p-1 bg-maincolor text-light border-light border-[1px] text-sm mr-1 flex flex-row items-center`}><FaWater /><span className='ml-1'>{dictionary.seaView}</span></div>
                            ) : null} */}
                            {/* {property.isBeachfront ? (
                                <div className={`rounded-md p-1 bg-third text-light border-third border-[1px] text-sm mr-1 flex flex-row items-center`}><MdBeachAccess /><span className='ml-1'>{dictionary.beachfront}</span></div>
                            ) : null} */}
                            {/* {property.isMountainView ? (
                                <div className={`rounded-md p-1 text-secondary border-secondary border-[1px] text-sm mr-1 flex flex-row items-center`}><FaMountain /><span className='ml-1'>Mountain View</span></div>
                            ) : null} */}
                        </div>
                    ) : null}
                    {/* {property.publicTransport ? (
                        <div className='absolute flex flex-row flex-wrap bottom-0 left-0'>
                            {property.publicTransport.map((transport, index) => (
                                <div key={index} style={{ backgroundColor: transport.colorCode }} className={`rounded-sm px-1 text-light text-sm ml-1 mb-1`}>{transport.type.toUpperCase()} {transport.stationName}</div>
                            ))}
                        </div>
                    ) : null} */}
                </div>
                <div className='p-2'>
                    {/* <div className='text-maincolor text-xl font-semibold rounded-r-md z-10'><h3>{property.category} for {property.saleType !== 'salerent' ? property.saleType : 'Sale and Rent'}</h3></div> */}
                    <div className='text-maincolor text-xl font-semibold rounded-r-md z-10 h-[60px]'><h3 className='line-clamp-2'>{property.name}</h3></div>
                    {property.oldSalePrice && (
                        <div className='line-through text-gray-400 flex flex-row'><CurrencySymbol />{property.oldSalePrice}</div>
                    )}
                    <div className='flex sm:flex-row flex-col w-full '>
                        {property.salePrice && (
                            <div className='text-xl font-semibold text-third w-1/2'><CurrencySymbol />{property.salePrice}</div>
                        )}
                    </div>
                    {/* <div className='w-full border-b-[1px] border-forth pb-1 mb-1'>
                        <p className='text-secondary text-xl'>{property.districts[0]?.subdistrictName?.[lang] ? property.districts[0]?.subdistrictName?.[lang] : property.districts[0]?.subdistrict}</p>
                    </div> */}
                    {(property.metaCategory == 'Condo' || property.metaCategory == 'House' || property.metaCategory == 'Poolvilla') &&
                        <div className='flex flex-row w-full'>
                            <div className='flex flex-row items-center w-1/2'>
                                <FaBed
                                    color={tailwindConfig.theme.extend.colors.secondary}
                                />
                                <span className='ml-2 text-xl text-maincolor'>{property.bedrooms} {dictionary.beds}</span>
                            </div>
                            <div className='flex flex-row items-center w-1/2'>
                                <FaBath
                                    color={tailwindConfig.theme.extend.colors.secondary}
                                />
                                <span className='ml-2 text-xl text-maincolor'>{property.bathrooms} {dictionary.baths}</span>
                            </div>
                        </div>

                    }
                    <div className='flex flex-row w-full justify-between'>
                        {(property.metaCategory !== 'Land' && property.livingArea > 0) &&
                            <div className='flex flex-row items-center w-1/2'>
                                <BiArea
                                    color={tailwindConfig.theme.extend.colors.secondary}
                                />
                                <span className='ml-2 text-xl text-maincolor'>{property.livingArea} {dictionary.sqm}</span>
                            </div>
                        }
                        {(property.metaCategory == 'Land' || property.landArea > 0) &&
                            <div className='flex flex-row items-center w-1/2'>
                                <BiSolidArea
                                    color={tailwindConfig.theme.extend.colors.secondary}
                                />
                                <span className='ml-2 text-xl text-maincolor'>{property.landArea} {dictionary.sqm}</span>
                            </div>
                        }
                    </div>
                </div>
            </LinkComponent >
        </div>
    )
}

export default LayoutCard